import { render } from "./GuideHole.vue?vue&type=template&id=08e39320&scoped=true"
import script from "./GuideHole.vue?vue&type=script&lang=js"
export * from "./GuideHole.vue?vue&type=script&lang=js"

import "./GuideHole.vue?vue&type=style&index=0&id=08e39320&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e39320"]])

export default __exports__